import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GAMES } from "@/content/landing";
import Reveal from "./Reveal";

export default function GamesStrip() {
  return (
    <section className="landing-section games-strip" id="jeux">
      <Reveal className="section-intro section-intro-row">
        <div><span className="eyebrow">{GAMES.eyebrow}</span><h2>{GAMES.title}</h2></div>
        <Link to={GAMES.more.to} className="landing-link">{GAMES.more.label}<ArrowRight size={13} /></Link>
      </Reveal>
      <Reveal as="ul" className="game-chips" delay={0.06}>
        {GAMES.list.map(g => <li key={g}><Link to="/games">{g}</Link></li>)}
      </Reveal>
    </section>
  );
}
